import { Component, OnDestroy, OnInit } from '@angular/core';
import { ComplexAttachements } from '../../models/complex-attachements';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ComplexAttachementsService } from '../../services/complex-attachements-service';
import { uploadService } from './../../../../shared/uploadService';
import { AddingWithAttatchementsBaseComponent } from '../../../../shared/Components/adding-with-attatchements-base/adding-with-attatchements-base.component';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';

@Component({
  selector: 'add-complex-attachements',
  templateUrl: './add-complex-attachements.component.html',
  styleUrls: ['./add-complex-attachements.component.scss'],
})
export class AddComplexAttachementsComponent extends AddingWithAttatchementsBaseComponent implements OnInit {
  model: ComplexAttachements;
  isEdit = false;
  formData: FormData = new FormData();
  isLoading: boolean = false;
  constructor(
    private route : Router,
    public diagRef: NbDialogRef<AddComplexAttachementsComponent>,
    public service: ComplexAttachementsService,
    public toast: NbToastrService,
    private uploadService: uploadService,
  ) {
    super(service, null);
      }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
    }
    if (!this.isEdit) {
      this.model = {} as ComplexAttachements;
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.model.imageDescription = '';
      this.model.imageDescriptionEN ='';
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  close() {
    this.diagRef.close();
  }

  isAttachementsValid() {
    if (!this.uploadService.isFilesEmpty() || !this.uploadService.isPrevAttachementsEmpty()) return true;

    return false;
  }

  save(form) {
    this.isLoading = true;
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([attachments$])
      .pipe(
        catchError(() => {
          console.log('error here in combine latest ');
          this.isLoading = false;
          return of(null);
        }),

        switchMap(([img]) => {
          // Update the model with the uploaded image and attachments
          // this.model.attachements = {
          //   fileName: img.fileName,
          //   originalFileName: img.originalFileName,
          // } as FileVm;

          this.model.attachements = img;

          // .res.map((ele:FileVm) => { return {
          //   originalFileName:ele ,
          //   fileName :ele
          // }});

          // Return the observable that saves the entity
          // return this.saveEntity(this.model);

          return this.saveEntity(this.model);
        }),
        tap(([img, attachments]) => {})
      )
      .subscribe(
        (res) => {
          this.isLoading = false;

          this.diagRef.close('true');
          this.toast.show('تم إضافة مرفق المجمع بنجاح', '', { status: 'success', duration: 3000 });
        },
        () => {
          this.isLoading = false;

          this.diagRef.close('true');
        }
      );
  }

  saveEntity(model): Observable<any> {
    return this.service.post(model);
  }

  update() {
    this.isLoading = true;
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([attachments$])
      .pipe(
        switchMap(([attachments]) => {
          // Update the model with the uploaded image and attachments

          this.model.attachements = attachments;
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل مرفق المجمع بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل مرفق المجمع', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }
}
